import { render, staticRenderFns } from "./EventCalendarEventReadOnly.vue?vue&type=template&id=1cd08320&"
import script from "./EventCalendarEventReadOnly.vue?vue&type=script&lang=ts&"
export * from "./EventCalendarEventReadOnly.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports